export default __webpack_public_path__ + "static/media/chat10.a80a0083.jpg";